// extracted by mini-css-extract-plugin
export default {"licenseTable":"licenseTable_licenseTable__clEZP"};